import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import { AuthenticationService } from './authentication.service';
import { EnvironmentService } from './index';
import { Tyre } from '../_models/tyre';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';


@Injectable()
export class TyresService {
  private baseUrl: string = this.environmentService.getBaseURL() + '/api';

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService) {
  }

  getAll(): Observable<Tyre[]>{
    let tyre$ = this.http
      .get(`${this.baseUrl}/tyres`, this.makeHeaders())
      .map(mapTyres)
      .catch(handleError);
    return tyre$;
  }

  get(id: string): Observable<Tyre> {
    let tyre$ = this.http
      .get(`${this.baseUrl}/tyres/${id}`, this.makeHeaders())
      .map(mapTyre);
    return tyre$;
  }

  getDealer(id: string): Observable<Tyre[]>{
    let tyre$ = this.http
      .get(`${this.baseUrl}/tyres?dealer_id=${id}`, this.makeHeaders())
      .map(mapTyres)
      .catch(handleError);
    return tyre$;
  }

  save(tyre: Tyre): Observable<Response> {
    // this won't actually work because the StarWars API doesn't
    // is read-only. But it would look like this:
    return this.http
      .put(`${this.baseUrl}/tyres/${tyre._id}`, JSON.stringify(tyre), this.makeHeaders());
  }

  create(tyre: Tyre): Observable<Tyre> {
    let newtyre$ = this.http
      .post(`${this.baseUrl}/tyres`, JSON.stringify(tyre), this.makeHeaders())
      .map(mapTyre);
    return newtyre$;
  }

  clone(tyreToBeCloned: Tyre, clone: Tyre): Observable<Tyre> {
    return this.http
      .post(`${this.baseUrl}/tyres/${clone._id}/clone`, JSON.stringify(tyreToBeCloned), this.makeHeaders())
      .map(mapTyre);
  }

  delete(id: String): Observable<Response> {
    return this.http
      .delete(`${this.baseUrl}/tyres/${id}`, this.makeHeaders())
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
      .catch((error: any) => Observable.throw(error.json().error || 'Server error')); //...errors if any
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append('Authorization', this.authenticationService.getToken());
    headers.append('Content-Type', 'application/json ');
    headers.append('charset', 'UTF-8 ');
    headers.append('Accept', 'application/json ');

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}

function mapTyres(response: Response): Tyre[]{
  // uncomment to simulate error:
  // throw new Error('ups! Force choke!');
  return response.json().map(toTyre);
}

function mapTyre(response:Response): Tyre{
  // toPerson looks just like in the previous example
  return toTyre(response.json());
}

function toTyre(r:any): Tyre {
  let tyre = <Tyre>({
    _id: r._id,
    width: r.width,
    profile: r.profile,
    diameter: r.diameter,
    type: r.type,
    quality: r.quality,
    price: r.price,
    manufacturer: r.manufacturer,
    dealer_id: r.dealer_id
  });
  // console.log('Parsed tyre:', tyre);
  return tyre;
}

function handleError (error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/_services/tyres.service.ts